
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoadHist } from '../Models/LoadsData';

@Injectable({
  providedIn: 'root'
})
export class PsegLoadHistService {

histData : Observable<Array<LoadHist>> ;

constructor(private http: HttpClient) { }

getPSEGHistData(histType: string): Observable<Array<LoadHist>> {
  this.histData = this.http.get<Array<LoadHist>>('api/PsegloadHists/' + histType)
    .pipe    (
      catchError(this.handleError<LoadHist[]>('getPSEGHistData', []))
    );
    return this.histData;
}

/**
* Handle Http operation that failed.
* Let the app continue.
* @param operation - name of the operation that failed
* @param result - optional value to return as the observable result
*/
private handleError<T>(operation = 'operation', result?: T) {
  return (error: any): Observable<T> => {

    // TODO: send the error to remote logging infrastructure
    console.error(error); // log to console instead

    // TODO: better job of transforming error for user consumption
    console.error(`${operation} failed: ${error.message}`);

    // Let the app keep running by returning an empty result.
    return of(result as T);
  };
}
}

